// import React from "react";
// import { Bar } from "react-chartjs-2";

// const SalesPieReport = ({
//   data,
//   options,
//   formatSales,
//   storess,
//   range,
//   chartRef,
//   containerId,
// }) => {
//   const startDate = range?.tran_date?.$lte?.split("T")[0] || "";
//   const endDate = range?.tran_date?.$gte?.split("T")[0] || "";

//   return (
//     <div ref={chartRef} id={containerId}>
//       <div className="card pb-4">
//         <Bar data={data} options={options} />
//       </div>

//       <div className="print-only-content">
//         <h2>Report Details</h2>
//         <div className="d-flex justify-content-between align-items-center print-only-content">
//           <h3>Brand: Angels Pizza</h3>
//           <h4 className="mx-auto"></h4>
//           <h3>Store: {storess}</h3>
//           <h3>Date: {`${startDate} ${endDate}`}</h3>
//         </div>

//         <div style={{ fontSize: "20px" }}>
//           <table className="table text-center">
//             <thead>
//               <tr className="d-flex">
//                 <th>Month</th>
//                 <th className="ms-5">Sales</th>
//               </tr>
//             </thead>
//             <tbody>
//               {data.labels.map((label, index) => (
//                 <tr className="d-flex" key={`${containerId}-${label}`}>
//                   <td>{label}</td>
//                   <td>{formatSales(data.datasets[0].data[index])}</td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SalesPieReport;

import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const SalesPieReport = ({
  data, // your ChartJS-like data from chartData()
  formatSales, // keep if you want formatting (or rename to formatCount)
  storess,
  range,
  chartRef,
  containerId,
}) => {
  // FIX: typically gte = start, lte = end
  const startDate = range?.tran_date?.$gte?.split("T")[0] || "";
  const endDate = range?.tran_date?.$lte?.split("T")[0] || "";

  const labels = data?.labels || [];
  const values = data?.datasets?.[0]?.data || [];
  const colors = data?.datasets?.[0]?.backgroundColor || [];

  // Build Highcharts series data (color per point)
  const seriesData = labels.map((name, i) => ({
    name,
    y: Number(values[i] ?? 0),
    color: colors[i] || undefined,
  }));

  const options = {
    chart: {
      type: "bar", // horizontal bars
      height: 260,
      spacingLeft: 10,
      spacingRight: 20,
    },
    title: {
      text: "Transaction Type Distribution",
      style: { fontSize: "14px" },
    },
    credits: { enabled: false },
    legend: { enabled: true },

    xAxis: {
      // Value axis (top like your screenshot)
      opposite: true, // puts axis on top for bar charts
      title: { text: null },
      labels: {
        formatter: function () {
          // if you want 250M style labels
          const v = this.value;
          if (Math.abs(v) >= 1e6) return `${(v / 1e6).toFixed(0)}M`;
          if (Math.abs(v) >= 1e3) return `${(v / 1e3).toFixed(0)}K`;
          return `${v}`;
        },
      },
      gridLineWidth: 1,
    },

    yAxis: {
      categories: labels, // categories on left
      title: { text: null },
      reversed: true, // top-to-bottom order like screenshot
      lineWidth: 1,
      gridLineWidth: 0,
    },

    tooltip: {
      formatter: function () {
        const val = this.point.y;
        return `<b>${this.point.name}</b>: ${formatSales ? val : val}`;
      },
    },

    plotOptions: {
      series: {
        animation: false,
        borderWidth: 1,
        pointPadding: 0.05,
        groupPadding: 0.1,
        dataLabels: {
          enabled: true,
          // show label at end of bar like screenshot
          inside: false,
          align: "right",
          // push label outside bar end
          x: 6,
          formatter: function () {
            const val = this.y;
            return formatSales ? val : val.toLocaleString();
          },
          style: {
            fontSize: "10px",
            fontWeight: "normal",
            textOutline: "none",
          },
        },
      },
    },

    series: [
      {
        name: "Count",
        data: seriesData,
      },
    ],
  };

  return (
    <div ref={chartRef} id={containerId}>
      <div className="card pb-4">
        <HighchartsReact highcharts={Highcharts} options={options} />
      </div>

      <div className="print-only-content">
        <h2>Report Details</h2>
        <div className="d-flex justify-content-between align-items-center print-only-content">
          <h3>Brand: Angels Pizza</h3>
          <h4 className="mx-auto"></h4>
          <h3>Store: {storess || "All Stores"}</h3>
          <h3>Date: {`${startDate} - ${endDate}`}</h3>
        </div>

        <div style={{ fontSize: "20px" }}>
          <table className="table text-center">
            <thead>
              <tr className="d-flex">
                <th>Transaction Type</th>
                <th className="ms-5">Count</th>
              </tr>
            </thead>
            <tbody>
              {labels.map((label, index) => (
                <tr className="d-flex" key={`${containerId}-${label}`}>
                  <td>{label}</td>
                  <td>
                    {formatSales
                      ? formatSales(values[index] ?? 0)
                      : (values[index] ?? 0)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SalesPieReport;
